export const OWNERSHIP_CHANGE_PACKET = "v2/ownership-change-packets";
export const OCP_DOCUMENT_TYPES = "v1/ocp-document-types";
